export default {
	'report-dish-cost': {
		id: 'report-dish-cost',
		label: '菜品成本结构表',
		code: '0008_0005'
	}
}
